import React from "react";
import { ITEM_TYPES } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { selectCls } from "@/components/stock/LineItemsEditor";
import { WarehouseSelect } from "@/components/stock/FormField";

const Field = ({ label, children }) => (
  <div className="min-w-[150px]">
    <Label className="text-xs uppercase tracking-wider text-slate-500">{label}</Label>
    <div className="mt-1">{children}</div>
  </div>
);

export const CATEGORIES = ["manual", "po", "used", "transfer", "conversion", "adjust", "opname", "shipment", "opening"];

export const StockFilters = ({ value, onChange, showDirection = false, showWarehouse = false, showCategory = false, warehouseAllLabel, testid = "filter" }) => {
  const { t } = useLang();
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="flex flex-wrap gap-3 items-end">
      <Field label={t("start_date")}>
        <Input type="date" className="h-9" value={value.start} onChange={set("start")} data-testid={`${testid}-start`} />
      </Field>
      <Field label={t("end_date")}>
        <Input type="date" className="h-9" value={value.end} onChange={set("end")} data-testid={`${testid}-end`} />
      </Field>
      {showWarehouse && (
        <Field label={t("warehouse")}>
          <WarehouseSelect value={value.warehouse} onChange={(v) => onChange({ ...value, warehouse: v })} allLabel={warehouseAllLabel || t("all")} testid={`${testid}-warehouse`} />
        </Field>
      )}
      <Field label={t("kind")}>
        <select className={selectCls} value={value.item_type} onChange={set("item_type")} data-testid={`${testid}-item-type`}>
          <option value="">{t("all")}</option>
          {ITEM_TYPES.map((x) => <option key={x.v} value={x.v}>{t(x.labelKey)}</option>)}
        </select>
      </Field>
      {showDirection && (
        <Field label={t("txn_type")}>
          <select className={selectCls} value={value.direction} onChange={set("direction")} data-testid={`${testid}-direction`}>
            <option value="">{t("all")}</option>
            <option value="in">IN</option>
            <option value="out">OUT</option>
          </select>
        </Field>
      )}
      {showCategory && (
        <Field label={t("source")}>
          <select className={selectCls} value={value.ref_type} onChange={set("ref_type")} data-testid={`${testid}-category`}>
            <option value="">{t("all")}</option>
            {CATEGORIES.map((c) => <option key={c} value={c}>{t(`src_${c}`)}</option>)}
          </select>
        </Field>
      )}
    </div>
  );
};

export const cleanParams = (obj) => Object.fromEntries(Object.entries(obj).filter(([, v]) => v));
